import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { PanelPage } from '../../components/pages/pages';
import OneClickButton from '../../components/form/button';
import DualList from '../../components/pages/DualList';
import Form from '../../components/form/form';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportAdminGeneralStorageAddress extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          {I18n.t('BEE12' /* Início */)}
                </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1389' /* Cadastros */) },
      { value: I18n.t('BEE14' /* Gerais */) },
      { value: I18n.t('BEE20' /* Endereços */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE145' /* Filial */),
        value: 'branchCode',
      },
      {
        label: I18n.t('BEE1754' /* Código Range */),
        value: 'rangeCode',
      },
      {
        label: I18n.t('BEE1755' /* Código Endereço */),
        value: 'code',
      },
      {
        label: I18n.t('BEE2372' /* Nome Endereço */),
        value: 'name',
      },
      {
        label: I18n.t('BEE279' /* Setor */),
        value: 'sector',
      }, {
        label: I18n.t('BEE121' /* Rua */),
        value: 'street',
      }, {
        label: I18n.t('BEE281' /* Coluna */),
        value: 'column',
      }, {
        label: I18n.t('BEE283' /* Nível */),
        value: 'level',
      }, {
        label: I18n.t('BEE285' /* Gaveta */),
        value: 'drawer',
      }, {
        label: I18n.t('BEE207' /* Bloqueado */),
        value: 'blocked',
      }, {
        label: I18n.t('BEE1855' /* Tamanho */),
        value: 'size',
      }, {
        label: I18n.t('BEE386' /* Altura */),
        value: 'height',
      }, {
        label: I18n.t('BEE387' /* Largura */),
        value: 'width',
      }, {
        label: I18n.t('BEE388' /* Comprimento */),
        value: 'length',
      }, {
        label: I18n.t('BEE727' /* Capacidade (Volume) */),
        value: 'capacityVolume',
      }, {
        label: I18n.t('BEE726' /* Capacidade (Peso) */),
        value: 'capacityWeight',
      }, {
        label: I18n.t('BEE575' /* Usuário de criação */),
        value: 'createdUser',
      }, {
        label: I18n.t('BEE578' /* Data de criação */),
        value: 'createdAt',
      }, {
        label: I18n.t('BEE576' /* Usuário de alteração */),
        value: 'updatedUser',
      }, {
        label: I18n.t('BEE577' /* Data de alteração */),
        value: 'updatedAt',
      },
    ];

    this.state = {
      selected: [],
      rangeCodeFrom: '',
      rangeCodeTo: '',
      codeFrom: '',
      codeTo: '',
      nameFrom: '',
      nameTo: '',
      branchCodeFrom: '',
      branchCodeTo: '',
      sectorFrom: '',
      sectorTo: '',
      streetFrom: '',
      streetTo: '',
      levelFrom: '',
      levelTo: '',
      columnFrom: '',
      columnTo: '',
      drawerFrom: '',
      drawerTo: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      rangeCodeFrom,
      rangeCodeTo,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      branchCodeFrom,
      branchCodeTo,
      sectorFrom,
      sectorTo,
      streetFrom,
      streetTo,
      levelFrom,
      levelTo,
      columnFrom,
      columnTo,
      drawerFrom,
      drawerTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['rangeCode', { type: 'between', value: [rangeCodeFrom, rangeCodeTo] }],
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['branchCode', { type: 'between', value: [branchCodeFrom, branchCodeTo] }],
      ['sector', { type: 'between', value: [sectorFrom, sectorTo] }],
      ['street', { type: 'between', value: [streetFrom, streetTo] }],
      ['level', { type: 'between', value: [levelFrom, levelTo] }],
      ['column', { type: 'between', value: [columnFrom, columnTo] }],
      ['drawer', { type: 'between', value: [drawerFrom, drawerTo] }],
    ]);

    this.props.generateReport(
      I18n.t('BEE20' /* Endereços */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  /* onGeneratePdf = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      branchNameFrom,
      branchNameTo,
      sectorFrom,
      sectorTo,
      streetFrom,
      streetTo,
      levelFrom,
      levelTo,
      columnFrom,
      columnTo,
      drawerFrom,
      drawerTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map(it => ({ ...(this.options.find(itb => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['branchName', { type: 'between', value: [branchNameFrom, branchNameTo] }],
      ['sector', { type: 'between', value: [sectorFrom, sectorTo] }],
      ['street', { type: 'between', value: [streetFrom, streetTo] }],
      ['level', { type: 'between', value: [levelFrom, levelTo] }],
      ['column', { type: 'between', value: [columnFrom, columnTo] }],
      ['drawer', { type: 'between', value: [drawerFrom, drawerTo] }],
    ]);

    this.props.generateReport(I18n.t('BEE20'  Endereços ).toLowerCase(), 'pdf', location.pathname, headers, filters);
  } */

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      rangeCodeFrom,
      rangeCodeTo,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      branchCodeFrom,
      branchCodeTo,
      sectorFrom,
      sectorTo,
      streetFrom,
      streetTo,
      levelFrom,
      levelTo,
      columnFrom,
      columnTo,
      drawerFrom,
      drawerTo,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE20' /* Endereços */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: branchCodeFrom, to: branchCodeTo },
                    { from: 'branchCodeFrom', to: 'branchCodeTo' },
                    `${I18n.t('BEE1994' /* Código Filial */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: rangeCodeFrom, to: rangeCodeTo },
                    { from: 'rangeCodeFrom', to: 'rangeCodeTo' },
                    `${I18n.t('BEE1754' /* Código Range */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: codeFrom, to: codeTo },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE1755' /* Código Endereço */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: nameFrom, to: nameTo },
                    { from: 'nameFrom', to: 'nameTo' },
                    `${I18n.t('BEE2372' /* Nome Endereço */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: sectorFrom, to: sectorTo },
                    { from: 'sectorFrom', to: 'sectorTo' },
                    `${I18n.t('BEE279' /* Setor */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: streetFrom, to: streetTo },
                    { from: 'streetFrom', to: 'streetTo' },
                    `${I18n.t('BEE121' /* Rua */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: columnFrom, to: columnTo },
                    { from: 'columnFrom', to: 'columnTo' },
                    `${I18n.t('BEE281' /* Coluna */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: levelFrom, to: levelTo },
                    { from: 'levelFrom', to: 'levelTo' },
                    `${I18n.t('BEE283' /* Nível */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: drawerFrom, to: drawerTo },
                    { from: 'drawerFrom', to: 'drawerTo' },
                    `${I18n.t('BEE285' /* Gaveta */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <>
            <OneClickButton
              type="button"
              style={{ width: 'auto', padding: 10 }}
              className="btn btn-primary p-5 m-5"
              onClick={this.onGenerateSpreadsheet}
            >
              {I18n.t('BEE544' /* Gerar Planilha */)}
            </OneClickButton>
            {/*  <button
              type="button"
              style={{ width: 'auto', padding: 10 }}
              className="btn btn-secondary p-5 m-5"
              onClick={this.onGeneratePdf}
            >
              {I18n.t('BEE545'  Gerar PDF )}
            </button> */}
          </>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportAdminGeneralStorageAddress);
